import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NbIconModule } from '@nebular/theme';
import { AiAssistanceComponent } from './ai-assistance.component';
import { AiAssistanceRoutingModule } from './ai-assistance-routing.module';

@NgModule({
  declarations: [AiAssistanceComponent],
  imports: [CommonModule, FormsModule, NbIconModule, AiAssistanceRoutingModule],
  exports: [AiAssistanceComponent]
})
export class AiAssistanceModule {}